import {
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  RadioGroup,
  TextField,
  TextareaAutosize,
  Typography,
} from "@mui/material";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCheckbox,
  CustomInputLabel,
  CustomRadioButton,
  CustomRequiredInputLabel,
  VisibilityIcon,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import styles from "./authorize.module.scss";
import printIcon from "../../../assets/PrintIcon.svg";
import { useEffect, useRef, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import toast, { Toaster } from "react-hot-toast";
import { CustomTextFeild } from "../../volunteerRegistration/below18Component";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import ErrorPopup from "../../common/ErrorPopup";
import CONSTANTS from "../../../config/constants.json";
import SuccessPopup from "../../devotee/donation/successPopup";
import Pagination from "../../common/pagination/pagination";
import ViewExpenseRequest from "../PrintVoucher/ViewExpenseRequest/ViewExpenseRequest";
import { BounceLoader, ClipLoader } from "react-spinners";

const NotAuthorizedByPCC = ({ category }: any) => {
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [openCancelDialog, setOpenCancelDialog] = useState(false);
  const [authorizeDetails, setAuthorizeDetails] = useState<any[]>([]);
  const [formData, setFormData] = useState({
    comments: "",
    password: "",
  });
  const [selectCheck, setSelectCheck] = useState<boolean>(false);
  const [authStatus, setAuthStatus] = useState<any>("");
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const prevPageNumber = usePrevious(pageNumber);
  const [pageSize, setPageSize] = useState<number>(20);
  const [openExpenseRequestDialog, setOpenExpenseRequestDialog] =
    useState(false);
  const [referenceNumber, setReferenceNumber] = useState<string>("");
  const [dialogTitle, setDialogTitle] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [passwordError, setPasswordError] = useState<string>("");
  const [loadingButton, setLoadingButton] = useState(false);
  const [viewRequestDetails, setViewRequestDetails] = useState(false);

  function usePrevious(value: any) {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]);

    return ref.current;
  }

  useEffect(() => {
    getAPI();
    if (prevPageNumber !== undefined && prevPageNumber !== pageNumber) {
      getAPI();
    }
  }, [pageNumber, prevPageNumber, pageSize]);

  useEffect(() => {
    getCategoryName();
  }, [category]);

  const getAPI = () => {
    setLoading(true);
    apiRequest({
      method: "GET",
      endpoint: apiPath.getExpensesNotToAuthorizeBy,
      includeToken: true,
      params: {
        page: pageNumber - 1,
        size: 50,
        categoryName:category,
      },
    })
      .then((res) => {
        setAuthorizeDetails(res.data.content);
        setTotalRecords(res.data.totalElements);
        setLoading(false);
        window.scrollTo({
          top: 300,
          left: 0,
          behavior: "smooth",
        });
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        toast.custom(
          <ErrorPopup showMessage={catchErrorMessageHandler(err)} />,
          {
            duration: CONSTANTS.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const UpdateApiCall = () => {
    if (!formData.password) {
      setPasswordError("Password is required.");
      return;
    }
    setLoadingButton(true);
    const getReferenceNumber = selectedRows.map((row: any) => {
      return row.referenceNumber;
    });
    const getAuthorizationStatus = selectedRows.map((row: any) => {
      return row.authStatus || "Approved";
    });  
    const reqBody = selectedRows.map((row: any) => {
      return {
        comments: row.comments || "",
        expenseRequestId: row.id,
      };
    });
    apiRequest({
      method: "PUT",
      endpoint: `${apiPath.ExpenseUpdateAuthorization}/${getReferenceNumber.join(",")}`,
      body: JSON.stringify(reqBody),
      includeToken: true,
      params: {
        password: formData.password,
        category: selectCheck,
        authorizationStatus: getAuthorizationStatus.join(",")
      },
    })
      .then((res) => {
        const successMessage = "Updated Successfully";
        toast.custom(
          <SuccessPopup
            headerMessage="Authorize Expense"
            showMessage={successMessage}
          />
        );
        setFormData({
          comments: "",
          password: "",
        });
        setOpenCancelDialog(false);
        setSelectedRows([]);
        setLoadingButton(false);
        getAPI();
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup showMessage={catchErrorMessageHandler(err)} />,
          {
            duration: CONSTANTS.TOAST_POPUP_DURATION,
          }
        );
        setLoadingButton(false);
      });
  };
  const getCategoryName = () => {
    switch (category) {
      case "Committeechairs":
        setDialogTitle("Authorize Expense Requests for Committee Chairs");
        break;
      case "President":
        setDialogTitle("Authorize Expense Requests for President");
        break;
      case "Chairman":
        setDialogTitle("Authorize Expense Requests for Chairman");
        break;
      case "Treasurer":
        setDialogTitle("Authorize Expense Requests for Treasurer");
        break;
      default:
        break;
    }
  };
  const handleCheckboxCategory = () => {
    setSelectCheck((prevCheck) => !prevCheck);
  };
  const handleRadioChange = (value: any, referenceNumber: any) => {
    setAuthStatus((prevState: any) => ({
      ...prevState,
      [referenceNumber]: value,
    }));
    const updatedRows = selectedRows.map((row, rowIndex) =>
      row.referenceNumber === referenceNumber
        ? { ...row, authStatus: value }
        : row
    );
    setSelectedRows(updatedRows);
  };

  const handleView = (referenceNum: any) => {
    setOpenExpenseRequestDialog(true);
    setReferenceNumber(referenceNum);
    setViewRequestDetails(true);
  };
  
  const handlePrint = (referenceNum: any) => {
    setOpenExpenseRequestDialog(true);
    setReferenceNumber(referenceNum);
  }

  const handleCheckboxChange = (referenceNumber: any) => {
    const selectedRow = authorizeDetails.find(
      (row) => row.referenceNumber === referenceNumber
    );

    if (selectedRow) {
      if (
        selectedRows.some((row: any) => row.referenceNumber === referenceNumber)
      ) {
        setSelectedRows((prev: any) =>
          prev.filter((row: any) => row.referenceNumber !== referenceNumber)
        );
      } else {
        setSelectedRows((prev: any) => [...prev, selectedRow]);
      }
    }
    if (selectedRows.length === authorizeDetails.length && !selectedRow) {
      setSelectedRows([]);
    }
  };

  const handleClose = (): void => {
    setOpenCancelDialog(false);
    setFormData({
      comments: "",
      password: "",
    });
  };

  const handleSubmit = () => {
    setOpenCancelDialog(true);
  };

  const handleFieldChange = (
    field: string,
    value: any,
    referenceNumber?: any
  ) => {
    setPasswordError("");
    if (field === "comments") {
      const updatedRows = selectedRows.map((row, rowIndex) =>
        row.referenceNumber === referenceNumber
          ? { ...row, comments: value }
          : row
      );
      setSelectedRows(updatedRows);
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };

  const commentsFieldComponent = (referenceNumber: any) => {
    return (
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid xs={30} sm={13} item>
          <TextareaAutosize
            id="comments"
            style={{
              height: "50px",
              backgroundColor: "#FFF9E4",
              border: "1px solid rgba(136, 46, 20, 0.4)",
              borderRadius: "8px",
            }}
            required
            value={formData.comments[referenceNumber]}
            onChange={(e) => {
              handleFieldChange("comments", e.target.value, referenceNumber);
            }}
          ></TextareaAutosize>
        </Grid>
      </Grid>
    );
  };

  const passwordFieldComponent = () => {
    return (
      <Grid container spacing={2} sx={{ marginTop: "0px" }}>
        <Grid xs={30} sm={13} item>
          {CustomRequiredInputLabel("Enter your password", true)}
          <CustomTextFeild
            id="password"
            required
            value={formData.password}
            onChange={(e) => {
              handleFieldChange("password", e.target.value);
            }}
            type="password"
          ></CustomTextFeild>
        </Grid>
      </Grid>
    );
  };

  const radioButtons = (referenceNumber: any): React.ReactElement => {
    return (
      <RadioGroup
        className={styles.formGroup}
        value={authStatus[referenceNumber] || "Approved"}
        onChange={(e) => handleRadioChange(e.target.value, referenceNumber)}
      >
        <FormControlLabel
          id="approve"
          value="Approved"
          control={
            <CustomRadioButton
              sx={{ "& .MuiSvgIcon-root": { fontSize: 14 } }}
            />
          }
          label={<span style={{ fontSize: 14 }}>Approve</span>}
        />
        <FormControlLabel
          id="reject"
          value="Rejected"
          control={
            <CustomRadioButton
              sx={{ "& .MuiSvgIcon-root": { fontSize: 14 } }}
            />
          }
          label={<span style={{ fontSize: 14, color: "red" }}>Reject</span>}
        />
        <FormControlLabel
          id="comment"
          value="Comments"
          control={
            <CustomRadioButton
              sx={{ "& .MuiSvgIcon-root": { fontSize: 14 } }}
            />
          }
          label={<span style={{ fontSize: 14 }}>Comments</span>}
        />
      </RadioGroup>
    );
  };

  const renderSelectedRows = () => {
    return (
      <Box>
        <div className={styles.mainContainer}>
          <div className={styles.tableWrapper}>
            <table className={styles.tableContainers}>
              <thead>
                <tr className={styles.headerTableRow}>
                  <th className={styles.tableHorizontal}>Referecnce Number</th>
                  <th className={styles.tableHorizontal}>Submitted on</th>
                  <th className={styles.tableHorizontal}>
                    Short Title (Reference Number)
                  </th>
                  <th className={styles.tableHorizontal}>Amount</th>
                  <th className={styles.tableHorizontal}>Expense Details</th>
                  <th className={styles.tableHorizontal}>View Details</th>
                  <th className={styles.tableHorizontal}>Approve/Reject</th>
                  <th className={styles.tableHorizontal}>Comments</th>
                </tr>
              </thead>
              <tbody>
                {selectedRows.map((row, index) => (
                  <tr className={styles.tableRow} key={index}>
                    <td className={styles.tableDiagonal}>
                      {row.referenceNumber}
                    </td>
                    <td className={styles.tableDiagonal}>{row.dateEntered}</td>
                    <td className={styles.tableDiagonal}>{row.shortTitle}</td>
                    <td className={styles.tableDiagonal}>{row.amount}</td>
                    <td className={styles.tableDiagonal}>
                      {row.expenseDetails
                        .split(";")
                        .map((row: any, index: any) => (
                          <div key={index}>{row}</div>
                        ))}
                    </td>
                    <td className={styles.tableDiagonal}>
                      <Box sx={{ display: "flex"}}>
                        <Box onClick={() => handleView(row?.referenceNumber)}>
                          <VisibilityIcon />
                        </Box>

                        <Box
                          component={"img"}
                          src={printIcon}
                          alt="Print"
                          onClick={() => handlePrint(row?.referenceNumber)}
                          sx={{
                            cursor: "pointer",
                            ml: { xs: "10px", md: "15px" },
                          }}
                        />
                      </Box>
                    </td>
                    <td className={styles.tableDiagonal}>
                      {radioButtons(row.referenceNumber)}
                    </td>

                    <td className={styles.tableDiagonal}>
                      {commentsFieldComponent(row.referenceNumber)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </Box>
    );
  };

  const dialogBoxOpen = (): React.ReactElement => {
    return (
      <Dialog
        open={openCancelDialog}
        onClose={handleClose}
        aria-labelledby="cancel-dialog-title"
        fullWidth
        maxWidth="xl"
        PaperProps={{
          style: {
            height: "calc(100% - 64px)",
            width: "calc(100% - 64px)",
            margin: "32px",
            maxWidth: "1148px",
            maxHeight: "644px",
            overflowY: "hidden",
            borderTopLeftRadius: "16px",
            borderTopRightRadius: "16px",
          },
        }}
      >
        <Box
          style={{
            backgroundColor: "#882E14",
            width: "auto",
          }}
        >
          <DialogTitle
            sx={{ fontWeight: 700, fontSize: "16px", color: "white" }}
          >
            {dialogTitle}
          </DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 24,
              top: 8,
              color: (theme: any) => theme.palette.grey[500],
            }}
          >
            <CloseIcon sx={{ color: "white" }} />
          </IconButton>
        </Box>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            className={styles.authorizeRequestContainer}
          >
            {renderSelectedRows()}
            <Grid>
              {passwordFieldComponent()}
              {passwordError && (
                <Typography sx={{ color: "red", fontSize: "12px" }}>
                  {passwordError}
                </Typography>
              )}
            </Grid>
            <Grid sx={{ display: "flex", alignItems: "center" }}>
              <CustomCheckbox
                id="categorycheck"
                checked={selectCheck}
                onChange={handleCheckboxCategory}
              />
              <CustomInputLabel>{`For ${category}`}</CustomInputLabel>
            </Grid>
            <Grid sx={{ margin: "10px 0px", display: "flex", gap: "10px" }}>
              <CommonButton
                onClick={UpdateApiCall}
                disabled={loadingButton}
                id="submitapi"
              >
                {loadingButton ? (
                  <>
                    <ClipLoader
                      color="#fff"
                      loading={loadingButton}
                      size={15}
                    />
                    <span
                      style={{
                        marginLeft: "8px",
                        fontSize: "15px",
                        textAlign: "center",
                      }}
                    >
                      loading...
                    </span>
                  </>
                ) : (
                  "Submit"
                )}
              </CommonButton>
              <CommonOutlinedButton onClick={handleClose}>Cancel</CommonOutlinedButton>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );
  };

  const itemsTableComponent = () => {
    return (
      <Box>
        <div className={styles.mainContainer}>
          <div className={styles.tableWrapper}>
            <table className={styles.tableContainers}>
              <thead>
                <tr className={styles.headerTableRow}>
                  <th className={styles.tableHorizontal}>Sr No</th>
                  <th className={styles.tableHorizontal}>Submitted on</th>
                  <th className={styles.tableHorizontal}>
                    Short Title (Reference Number)
                  </th>
                  <th className={styles.tableHorizontal}>Amount</th>
                  <th className={styles.tableHorizontal}>Expense Details</th>
                  <th className={styles.tableHorizontal}>
                    Send check on or before
                  </th>
                  <th className={styles.tableHorizontal}>Status</th>
                  <th className={styles.tableHorizontal}>
                    Multiple Authorisation
                  </th>
                  <th className={styles.tableHorizontal}>Action</th>
                </tr>
              </thead>
              <tbody>
                {authorizeDetails.map((item, index) => (
                  <tr className={`${styles.tableRow} ${item.priority === 'NORMAL' ? styles.tableCellBlack : item.priority === 'MODERATE' ? styles.tableCellGreen : styles.tableCellOrange}`} key={index} >
                    <td className={styles.tableDiagonal}>
                      {index + 1 + (pageNumber - 1) * 50}
                    </td>
                    <td className={styles.tableDiagonal}>{item.dateEntered}</td>
                    <td className={styles.tableDiagonal} style={{wordBreak: 'break-all'}}>
                      {item.shortTitle} ({item.referenceNumber})
                    </td>
                    <td className={styles.tableDiagonal} style={{textAlign:'right'}}>{formatAmount(item.amount)}</td>
                    <td className={styles.tableDiagonal}>
                      {item.expenseDetails
                        .split(";")
                        .map((item: any, index: any) => (
                          <div key={index} style={{maxWidth:'200px'}}>{item}</div>
                        ))}
                    </td>
                    <td className={styles.tableDiagonal}>
                      {item.mailCheckOnOrBefore}
                    </td>
                    <td className={styles.tableDiagonal}>{item.priority}</td>
                    <td className={styles.tableDiagonal}>
                      <CustomCheckbox
                        checked={selectedRows.some(
                          (selectedRow: any) =>
                            selectedRow.referenceNumber === item.referenceNumber
                        )}
                        onChange={() =>
                          handleCheckboxChange(item.referenceNumber)
                        }
                      />
                    </td>
                    <td className={styles.tableDiagonal}>
                      <Box sx={{ display: "flex" }}>
                        <Box onClick={() => handleView(item?.referenceNumber)}>
                          <VisibilityIcon />
                        </Box>

                        <Box
                          component={"img"}
                          src={printIcon}
                          alt="Print"
                          onClick={() => handlePrint(item?.referenceNumber)}
                          sx={{
                            cursor: "pointer",
                            ml: { xs: "10px", md: "15px" },
                          }}
                        />
                      </Box>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          {totalRecords > 0 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "end",
                marginRight: "10px",
              }}
            >
              <Pagination
                items={totalRecords}
                itemsPerPage={50}
                setPageNumber={setPageNumber}
                pageNumber={pageNumber}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </Box>
    );
  };

  const renderEmptyData = (): React.ReactElement => {
    return (
      <>
        {loading ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "300px",
            }}
          >
            <BounceLoader color="#22A699" loading={loading} size={45} />
            <span
              style={{
                marginLeft: "8px",
                fontSize: "15px",
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              Please wait...
            </span>
          </div>
        ) : (
          <Typography
            sx={{ margin: "24px auto", color: "red", fontSize: "28px" }}
          >
            <b>No Records found</b>
          </Typography>
        )}
      </>
    );
  };

  return (
    <Box className={styles.authorizeRequestContainer}>
      <Toaster />
      {dialogBoxOpen()}
      <Grid className={styles.authorizeRequestButton}>
        {authorizeDetails.length > 0 && <CommonButton id="submit" onClick={handleSubmit} disabled={selectedRows.length === 0} >Submit</CommonButton>}
      </Grid>
      <Grid>
        {/* {authorizeDetails.length > 0 ? itemsTableComponent() : 
        <Typography sx={{margin:"24px auto",color:"red",fontSize:"28px"}}><b>No Records found</b></Typography>} */}
        {authorizeDetails.length > 0
          ? itemsTableComponent()
          : renderEmptyData()}
      </Grid>
      {openExpenseRequestDialog && (
        <ViewExpenseRequest
          open={openExpenseRequestDialog}
          handleClose={() => {
            setOpenExpenseRequestDialog(false);
            setViewRequestDetails(false);
            setReferenceNumber("");
          }}
          referenceNumber={referenceNumber}
          viewRequest={viewRequestDetails}
        />
      )}
    </Box>
  );
};

export default NotAuthorizedByPCC;